module.exports = __webpack_public_path__ + "img/location.e674fc1b.svg";